class ComponentProductCard extends Theme.Component {
  #submitting = false;
  #controller = null;

  connectedCallback() {
    this.defineElements({
      form: "form"
    });

    this.defineElementCollections({
      links: "link[rel=prefetch]"
    });

    this.addEvent("submit", this.elements.form, this.onSubmit);
    this.addEvent("change", this, this.onChange);

    this.prefetchURLs();
    this.events();
  }

  prefetchURLs() {
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) {
          continue;
        }

        fetch(entry.href, { cache: "force-cache" });
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '100px' });

    this.elements.links.forEach((element) => {
      this.observer.observe(element);
    });
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.#submitting) {
      return;
    }

    this.#submitting = true;

    const data = new FormData(this.elements.form);

    fetch("/cart/add.js", {
      method: "POST",
      body: data
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent("addtocart", {
        detail: response
      }));
    })
    .catch(error => {
      console.error("ProductFormSubmitError: ", error);
    })
    .finally(() => {
      this.#submitting = false;
    });
  }

  onChange(event) {
    if (event.target.name == "id") {
      this.onVariantChange(event);
    }
  }

  onVariantChange(event) {
    this.render(event.target.value);
  }

  render(variant) {
    this.#controller?.abort();
    this.#controller = new AbortController();

    const url = new URL(this.attributes.url.value, location.origin);

    url.searchParams.set("view", "fragment-card");
    url.searchParams.set("variant", variant);

    fetch(url.href, { signal: this.#controller.signal })
      .then(response => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.getElementById(this.id);

        morphdom(this, fragment, { childrenOnly: true });
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          return;
        }
      })
      .finally(() => {
        this.#controller = null;
      });
  }
}

customElements.define("component-product-card", ComponentProductCard);
